exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".terms-dialog .tabs__wrapper{margin-left:0!important}#register-dialog{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}#register-dialog .card{width:600px;min-height:505px}#register-dialog #politica{position:relative}#register-dialog .check-layout{position:absolute;top:24px;left:28px}#privacy,#terms{-webkit-overflow-scrolling:touch;overflow-y:scroll}.terms-dialog iframe{height:100%;width:100%}.tabs__content,.terms-dialog{height:100%}.tabs__items{height:calc(100% - 48px)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./~/postcss-loader/lib!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/dialog/types/DialogTermsAndPolicy.vue
// module id = 1062
// module chunks = 22